import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Nosotros from "@/components/sections/Nosotros";
import Flota from "@/components/sections/Flota";
import Servicios from "@/components/sections/Servicios";
import Estudiantil from "@/components/sections/Estudiantil";
import StatsBand from "@/components/sections/StatsBand";
import Galeria from "@/components/sections/Galeria";
import PorQueElegirnos from "@/components/sections/PorQueElegirnos";
import Contacto from "@/components/sections/Contacto";
import Footer from "@/components/sections/Footer";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Flota />
      <Servicios />
      <Estudiantil />
      <StatsBand />
      <Galeria />
      <PorQueElegirnos />
      <Nosotros />
      <Contacto />
      <Footer />
    </main>
  );
}
